import { ExportOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Col, Row, Typography } from 'antd';
import React, { FC, PropsWithChildren, useMemo, useState } from 'react';
import { JLabel } from '../../../JForm/JLabel';
import { JModal } from '../../../JModal';
import { DEFAULT_HALF_COL_PROPS, TRANSLATION_CODES } from '../../constants';

import { JCMSCTA } from '../../../JCMSCTA';
import { JHTML } from '../../../JHTML';
import { JRadioProps } from './../../models';
import { useCompositorContext } from './../CompositorProvider';
import { FormItem } from './../FormItem';
import './GenericRadioContainer.scss';

const { Link } = Typography

export const GenericRadioContainer: FC<PropsWithChildren<JRadioProps & { className?: string }>> = (props) => {
    const { translate } = useCompositorContext()

    const [showModal, setShowModal] = useState(false);
    const [, setAccepted] = useState<boolean>(!!props.value);
    const hidden= useMemo(()=> props.hidden ?? false, [props.hidden])

    const openModal = () => setShowModal(true);
    const closeModal = () => setShowModal(false);
    const onAccept = () => {
        closeModal()
        setAccepted(true)
    }
    const readAllLabel = useMemo(() => {
        return translate(TRANSLATION_CODES.READ_ALL)
    }, [])
    const gotItLabel = useMemo(() => {
        return translate(TRANSLATION_CODES.GOT_IT)
    }, [])


    const openFile = () => {
        window.open(props.infoFileURL, "_blank")
    }

    const renderInfo = (callback: () => void, external?: boolean) => (

        <div onClick={callback} className='read-all'>
            <Link>{readAllLabel}</Link>
            {
                external ? (
                    <ExportOutlined aria-hidden={true}/>
                ) : (
                    <InfoCircleOutlined aria-hidden={true}/>
                )
            }
        </div>
    )
    return (
        <div>
            <Row className={`radio-container ${props.className} ${hidden ? 'hidden' : 'visible'}`}>
                <Col {...DEFAULT_HALF_COL_PROPS}>
                    {
                        props.label && (
                            props.showLabel ? (
                                <label>
                                    <JLabel label={props.label} />
                                </label>
                            ) : (
                                <div className='title'>{props.label}:</div>
                            )
                        )
                    }

                    {
                        props.placeholder && (
                            <small className='text' dangerouslySetInnerHTML={{__html: props.placeholder || ''}}/>
                        )
                    }
                    {
                        props.infoFileURL && (
                            <div className='dispCol'>
                                {renderInfo(openFile, true)}
                            </div>
                        )
                    }
                    {
                        props.description && (
                            <div className='dispCol'>

                                {renderInfo(openModal)}
                                <JModal
                                    width={700}
                                    isModalVisible={showModal}
                                    className='form-modal'
                                    handleCancel={closeModal}
                                    title={props.label}
                                    footer={null}
                                >
                                    <div>
                                        <JHTML.Text html={props.description}></JHTML.Text>
                                        <div className='form-modal-footer'>
                                            <JCMSCTA title={gotItLabel} action={onAccept} type='BUTTON' />
                                        </div>
                                    </div>
                                </JModal>
                            </div>
                        )
                    }
                </Col>
                <Col {...DEFAULT_HALF_COL_PROPS} >
                    <FormItem fieldProps={{ ...props, showLabel: false }}>
                        {props.children}
                    </FormItem>
                </Col>
            </Row>
        </div>
    )
}